import type {RowData, Table as ReactTable} from '@tanstack/react-table';
import {useTranslation} from 'react-i18next';

import {Button} from '@/components/ui/button';

import TableFilter from './TableFilter';
import TableSort from './TableSort';
import TableVisibility from './TableVisibility';

interface TableActionsProps<TData extends RowData> {
  table: ReactTable<TData>;
  showVisibility?: boolean;
  showFilter?: boolean;
  showSort?: boolean;
  children?: React.ReactNode;
  endChildren?: React.ReactNode;
}

function TableActions<TData extends RowData>({
  table,
  showFilter = true,
  showVisibility,
  showSort = true,
  children,
  endChildren,
}: TableActionsProps<TData>) {
  const {t} = useTranslation();

  const handleClean = () => {
    table.resetColumnFilters();
    table.resetSorting();
  };

  const showClear =
    !!table.getState().columnFilters.length ||
    !!table.getState().sorting.length;

  return (
    <div className="flex flex-row flex-wrap items-center gap-2">
      <div className="flex flex-row flex-wrap items-center gap-2">
        {children}
        {showFilter && <TableFilter table={table} />}
        {showVisibility && <TableVisibility table={table} />}
        {showSort && <TableSort table={table} />}
        {endChildren}
      </div>
      {showClear && (
        <Button
          className="p-2"
          variant="warning"
          size="small"
          onClick={handleClean}
        >
          {t('Clear All')}
        </Button>
      )}
    </div>
  );
}

export default TableActions;
